// extracted by mini-css-extract-plugin
export default {"variables":"\"../../../variables.module.css\"","font-size-middle-base":"15px","font-size-middle":"16px","description":"Description_description__AevIp"};